module.exports = __webpack_public_path__ + "img/gywm-5.8ffa3b10.jpg";